import 'reflect-metadata';
import React from 'react';
import ReactDOM from 'react-dom';
import './stylesheets/core.theme.scss';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

import App from './App';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { JsonPathReferenceHandler, TypeManager } from '@dipscope/type-manager';
import store, { history } from './reducers/store';

if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept();
}

TypeManager.applyTypeOptionsBase({
  referenceHandler: new JsonPathReferenceHandler(),
  preserveDiscriminator: true
});

Sentry.init({
  dsn: 'https://8d947af9b8424fca82a14b41334f95d2@sentry.io/295263',
  integrations: [new BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0
});

// If running inside a Facebook Instant Games iframe, FB injects FBInstant
// into the global scope before our scripts run. We must call initializeAsync()
// before any player APIs become available.
const fbInstantInit = typeof FBInstant !== 'undefined' ? FBInstant.initializeAsync() : Promise.resolve();

fbInstantInit.then(() => {
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
  );
});
